import { createSelector } from 'reselect';
import { EventStatus } from 'src/shared/enums/eventStatus.enum';
import { TYPES } from './constants';
import { createLoadingSelector } from '../@loadings';
import { createSuccessSelector } from '../@success';
import { createErrorSelector } from '../@errors';
import { EventsDataState } from './types';
import { ReduxState } from '../types';

export const selectEventsData = (state: ReduxState): EventsDataState => state.eventsData;
export const selectEvents = createSelector(selectEventsData, ({ events }) => events);

// It should be removed after adding pagination.
// /events/?openOnly=true
export const selectOpenEvents = createSelector(selectEvents, (events) =>
  // Technical Debts: event shoudn't have groups: upcoming, activate, past
  events.filter ? events.filter((event) => event.status !== EventStatus.CLOSED) : [],
);
export const selectEventsLoading = createLoadingSelector(TYPES.LOAD_EVENTS.TYPE);
export const selectEventsSuccess = createSuccessSelector(TYPES.LOAD_EVENTS.TYPE);
export const selectEventsError = createErrorSelector(TYPES.LOAD_EVENTS.TYPE);

export const selectFilteredEventsLoading = createLoadingSelector(TYPES.LOAD_FILTERED_EVENTS.TYPE);
export const selectFilteredEventsSuccess = createSuccessSelector(TYPES.LOAD_FILTERED_EVENTS.TYPE);
export const selectFilteredEventsError = createErrorSelector(TYPES.LOAD_FILTERED_EVENTS.TYPE);
